import * as set from './set.js';

export const config = [set];
